__turbopack_context__.v({
  "dot": "oChVPW_dot",
  "dotActive": "oChVPW_dotActive",
  "dots": "oChVPW_dots",
});
